import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// 路由配置
// import index from '@/page/index.vue';
import login from '@/page/login.vue';
import project from '@/page/project/project.vue';
// import approval from '@/page/approval.vue';
// import comment from '@/page/comment.vue';
// import document from '@/page/document.vue';
// import task from '@/page/task.vue';
// import summary  from '@/page/Briefing.vue';
// import projectDetail  from '@/page/project_detail.vue';
import approvalDetail from '@/page/approval_detail.vue';
// import documentDetail  from '@/page/document_detail.vue';
// import taskDetail  from '@/page/task_detail.vue';
// import bulletinDetail  from '@/page/bulletin_detail.vue';
import blankDetail from '@/page/blank.vue';
import preview from '@/page/preview.vue';
import main from '@/page/main.vue';
import auditing from '@/page/auditing/home.vue';
import auditing_welcome from '@/page/auditing/welcome.vue';
// import tester  from '@/components/addProjectpage.vue';
import auditing_detail from '@/page/auditing/auditing_detail.vue';
import create_auditing from '@/page/auditing/create_auditing.vue';
import create_project from '@/page/project/create_project.vue';
import project_welcome from '@/page/project/welcome.vue';
import project_detail from '@/page/project/project_detail.vue';
import project_files from '@/page/project/files.vue';
import approval_page from '@/page/approval/approval_page.vue';
import approval_detai1 from '@/page/approval/approval_detai1.vue';
// import test  from '@/page/test.vue';
// import table  from '@/page/table.vue';

Vue.use(Router)

var rr = new Router({
    routes: [
        { path: '/login', name: 'login', component: login, meta: { needCheck: true } },
        { path: '/approval_page', name: 'approval_page', component: approval_page },
        { path: '/approval_detail/:id', name: 'approval_detail', component: approval_detai1 },
        { path: '/blank/:id', name: 'blank', component: blankDetail },
        { path: '/preview', name: 'preview', component: preview },
        {
            path: '/main',
            name: 'main',
            component: main,
            children: [{
                    path: '/main/auditing',
                    name: '审批',
                    component: auditing,
                    children: [
                        { path: '/main/auditing/welcome', name: '审批', component: auditing_welcome },
                        { path: '/main/auditing/auditing_detail/:id', name: '审批详情', component: auditing_detail },
                        { path: '/main/auditing/auditing_create', name: '新建审批', component: create_auditing }
                    ]
                },
                {
                    path: '/main/project/project',
                    name: '项目',
                    component: project,
                    children: [
                        { path: '/main/project/welcome', name: '项目', component: project_welcome },
                        { path: '/main/project/create_project', name: '新建项目', component: create_project },
                        { path: '/main/project/project_detail/:id', name: '编辑项目', component: project_detail },
                        { path: '/main/project/project_files/:id', name: '项目文档', component: project_files }
                    ]
                },
            ]
        },
        { path: '*', redirect: '/main/project/welcome' }
    ]
});

rr.beforeEach((to, from, next) => {
    // console.log(to,window.token);
    if (to.meta.needCheck == undefined) {
        // console.log("has needCheck");
        var web_token = sessionStorage.getItem('web_token');
        if (web_token === null || web_token === undefined) {
            // console.log("less web_token ===> login");
            next({ "path": "/login" });
        } else {
            // console.log("has web_token");
            next();
        }
    } else {
        // console.log("less needCheck");
        next();
    }
});

export default rr


/*
  #/login
 1 #/main      menu | router-view
  #/main/project plist ref="list" | router-view  func(){ list. }
  #/main/project/welcome
  #/main/project/add
  #/main/project/mod
  #/main/project/item
  #/main/project/item/files?id=?
  #/main/project/item/visit?id=?
 1 #/main/auditing alist | router-view
 1 #/main/auditing/welcome
 1 #/main/auditing/add
 1 #/main/auditing/desc?id=?
 */


// WEBPACK FOOTER //
// ./src/router/index.js